package dev.krno.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import dev.krno.data.Speaker
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.events.Event

@Composable
fun SpeakerModal(speaker: Speaker, onClose: () -> Unit) {
    Div(attrs = { classes("spk-modal") }) {
        Div(attrs = {
            classes("spk-modal-backdrop")
            onClick { onClose() }
        })
        Div(attrs = { classes("spk-modal-panel") }) {
            Button(attrs = {
                classes("spk-modal-close")
                attr("type", "button")
                attr("aria-label", "Close details")
                onClick { onClose() }
            }) { Text("✕") }

            Div(attrs = { classes("spk-modal-media") }) {
                if (speaker.photo.isNotEmpty()) {
                    Img(src = speaker.photo, attrs = {
                        classes("spk-modal-photo")
                        attr("alt", speaker.name)
                    })
                }
            }

            Div(attrs = { classes("spk-modal-info") }) {
                if (speaker.role.isNotEmpty()) {
                    Div(attrs = { classes("spk-modal-role") }) { Text(speaker.role) }
                }
                H2(attrs = { classes("spk-modal-name") }) { Text(speaker.name.ifEmpty { "???" }) }
                if (speaker.talk.isNotEmpty()) {
                    H3(attrs = { classes("spk-modal-talk") }) { Text(speaker.talk) }
                }

                if (speaker.description.isNotEmpty()) {
                    speaker.description.split("\n\n").forEach { para ->
                        P(attrs = { classes("spk-modal-abstract") }) { Text(para) }
                    }
                } else {
                    P(attrs = { classes("spk-modal-abstract", "spk-modal-abstract-empty") }) {
                        Text("Details coming soon.")
                    }
                }
            }
        }
    }

    // Body scroll lock + Escape key handling. Effect ties to `speaker.name` so
    // reopening on a different talk re-arms the listener cleanly.
    DisposableEffect(speaker.name) {
        val bodyStyle = document.body?.style?.asDynamic()
        val prevOverflow = bodyStyle?.overflow as? String
        bodyStyle?.overflow = "hidden"

        val onKey: (Event) -> Unit = { evt ->
            val key = evt.asDynamic().key as? String
            if (key == "Escape") onClose()
        }
        window.addEventListener("keydown", onKey)

        onDispose {
            window.removeEventListener("keydown", onKey)
            bodyStyle?.overflow = prevOverflow ?: ""
        }
    }
}
